import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input, ViewChild, ElementRef, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { Formio } from '@formio/js/sdk';
import { AppConfig } from 'src/app/app.config';
import { FileDocument } from '../shared/models/file-document.model';
import { TranslocoService } from '@ngneat/transloco';


@Component({
  standalone: true,
  imports: [NgClass],
  selector: "app-formio-cardinal",
  templateUrl: "./formio-cardinal.component.html",
  styleUrls: ["./cardinal-formio.css",
    "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css",
    "../../../assets/styles/fontAwesomeBootstrap.css"
  ],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FormioCardinalComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() submitted = new EventEmitter<any>();
  @Output() readyChange = new EventEmitter<boolean>();
  @Input() formName: string;
  @Input() haveCloseAction = false;
  @Input() showZoomControls = true;
  @Input() fileDocument: FileDocument;

  @ViewChild('formio', { static: true }) formio: ElementRef;
  private readonly transloco = inject(TranslocoService);
  source: string;
  showForm = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formioForm: any;

  constructor() { }

  ngOnInit() {
    this.showForm = this.formName != undefined;
    this.formioForm = {};
    let docData;

    if (this.fileDocument) {
      docData = this.fileDocument.getFormiData().reduce(function (result, item) {
        const key = Object.keys(item)[0];
        result[key] = item[key];
        return result;
      }, {});
    }

    let formioConfig: string;
    if (!AppConfig.settings.application.formStage || AppConfig.settings.application.formStage.length < 1) {
      formioConfig = `https://${AppConfig.FormioAppConfig.appUrl}`;
    } else {
      formioConfig = `https://${AppConfig.settings.application.formStage}-${AppConfig.FormioAppConfig.appUrl}`;

    }
    Formio.createForm(this.formio.nativeElement, `${formioConfig}/${this.formName}`, {
      readOnly: false,
      // Mantener el iconset de la implementación legacy.
      iconset: 'fa',
      language: 'es',
      i18n: {
        es: this.getFormioTranslations()
      }
    }).then(formulario => {
      if (this.fileDocument) {
        // Defaults are provided as follows.
        formulario.submission = {
          data: docData
        };
      }


      this.formioForm = formulario;
      formulario.on('submit', (submission) => {
        this.onSubmit(submission);
      });
      this.readyChange.emit(true);
    }).catch(() => {
      this.readyChange.emit(false);
      this.submitted.emit(false);
    });

  }

  /**
   * Mensajes del motor Form.io en el idioma activo. Los placeholders propios de Form.io
   * ({{field}}, {{max}}, etc.) se pasan como parámetros para que Transloco los conserve.
   */
  private getFormioTranslations(): Record<string, string> {
    const K = 'formio.formioCardinal.';
    const keep = (...names: string[]) =>
      names.reduce((acc, n) => ({ ...acc, [n]: `{{${n}}}` }), {} as Record<string, string>);
    const t = (key: string, params?: Record<string, string>) => this.transloco.translate(key, params);
    return {
      Submit: t('common.endBtn'),
      complete: t(K + 'generatingFileLbl'),
      error: t(K + 'fixErrorsMsg'),
      invalid_date: t(K + 'invalidDateMsg', keep('field')),
      invalid_email: t(K + 'invalidEmailMsg', keep('field')),
      invalid_regex: t(K + 'invalidRegexMsg', keep('field', 'regex')),
      mask: t(K + 'maskMsg', keep('field')),
      max: t(K + 'maxMsg', keep('field', 'max')),
      maxLength: t(K + 'maxLengthMsg', keep('field', 'length')),
      min: t(K + 'minMsg', keep('field', 'min')),
      minLength: t(K + 'minLengthMsg', keep('field', 'length')),
      next: t('common.next'),
      pattern: t(K + 'patternMsg', keep('field', 'pattern')),
      previous: t('common.lastBtn'),
      required: t(K + 'requiredMsg', keep('field'))
    };
  }

  submitForm() {
    if (!this.formioForm || typeof this.formioForm.submit !== 'function') {
      this.submitted.emit(false);
      return;
    }

    try {
      const result = this.formioForm.submit();
      result?.catch?.(_e => {
        this.submitted.emit(false);
      });
    } catch {
      this.submitted.emit(false);
    }
  }


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit(submission: any) {
    this.submitted.emit(submission);
  }

}
